import { render, staticRenderFns } from "./ResponsiveChatBox.vue?vue&type=template&id=3af2617e&scoped=true&"
import script from "./ResponsiveChatBox.vue?vue&type=script&lang=js&"
export * from "./ResponsiveChatBox.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveChatBox.vue?vue&type=style&index=0&id=3af2617e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2617e",
  null
  
)

export default component.exports